import React, { ReactNode } from 'react';
import { Typography } from '@mui/material';

export function InheritedReadOnlyText({
	children,
	isInherited,
	style,
}: {
	isInherited: boolean;
	children: ReactNode;
	style?: React.CSSProperties;
}) {
	return (
		<Typography
			className={isInherited ? 'inherited' : 'default'}
			fontWeight={400}
			fontSize="14px"
			style={{
				marginLeft: 12,
				...style,
			}}
		>
			{children}
		</Typography>
	);
}
